export default __webpack_public_path__ + "static/media/notification_icon_white.5af3a344.svg";